/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-undef */
/* eslint-disable no-useless-catch */
/* eslint-disable react/prop-types */
import React from 'react';

import { graphql } from 'gatsby';

import { BlogPost, BlogPostSchema, SEO } from '@bluefin/components';

import './DefaultBlogPost.css';

export default function DefaultBlogPost({ data, pageContext }) {
  const {
    fishermanBusiness: { name: businessName, logo: businessLogo, businessCategories = [] },
    fishermanBusinessBlogPost: {
      title,
      publishedAt,
      heroImage,
      gatsbyHeroImage,
      author,
      content,
      summary,
    },
  } = data;
  const { firstName, lastName } = author || {};
  const authorName = firstName && lastName ? `${firstName} ${lastName}` : null;

  const { blogRootSlug } = pageContext;

  return (
    <div className="default-blog-wrapper">
      <SEO businessName={businessName} pageName={title} description={summary} truncateDescription />
      <BlogPostSchema
        businessName={businessName}
        businessCategories={businessCategories}
        businessLogo={businessLogo}
        title={title}
        datePublished={publishedAt}
        author={authorName}
        heroImage={heroImage}
        content={content}
        summary={summary}
      />
      <BlogPost
        title={title}
        heroImage={gatsbyHeroImage && gatsbyHeroImage.childImageSharp}
        publishedAt={publishedAt}
        author={author}
        content={content}
        summary={summary}
        markdown
        blogRootSlug={blogRootSlug}
      />
    </div>
  );
}

export const query = graphql`
  query ($id: Int!) {
    fishermanBusiness {
      name
      logo
      businessCategories {
        category
      }
    }
    fishermanBusinessBlogPost(_id: { eq: $id }) {
      _id
      summary
      title
      content
      heroImage
      gatsbyHeroImage {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      author {
        firstName
        lastName
        avatar
        email
      }
      publishedAt
    }
  }
`;
